<template>
  <div class="btn-create">
    <button class="btn btn-primary" @click="templatePage">
      <i class="icon icon-plus mr-1"></i>
      <span>{{ btnText }}</span>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { LANDING_PAGE_EVENT, HOME_PAGE_EVENT, PRODUCT_PAGE_EVENT, COLLECTION_PAGE_EVENT, BLOG_POST_EVENT } from "@/config/constants/trackEventIds";

export default {
  name: "ButtonCreatePage",
  props: {
    label: String,
    type: String
  },
  data() {
    return {};
  },
  computed: {
    btnText() {
      if (["homepages", "productpages", "collectionpages"].includes(this.type)) {
        return this.$t("page.btnCreate.template");
      }
      return this.$t("page.btnCreate.page");
    }
  },
  methods: {
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    itemCreateClick(fn) {
      if (this.$refs.moreActionCreate) {
        this.$refs.moreActionCreate.toggleDropdown();
      }
      if (fn) fn();
    },
    templatePage() {
      this.$emit("onClickTemplatePage");
      this.$emit("create", this.type);
      this.trackCreateNewEvent();
    },
    trackCreateNewEvent() {
      let eventId = null;

      switch (this.type) {
        case "subpages":
          eventId = LANDING_PAGE_EVENT.CREATE_NEW_CLICKED;
          break;
        case "articlepages":
          eventId = BLOG_POST_EVENT.CREATE_NEW_CLICKED;
          break;
        case "homepages":
          eventId = HOME_PAGE_EVENT.CREATE_NEW_CLICKED;
          break;
        case "collectionpages":
          eventId = COLLECTION_PAGE_EVENT.CREATE_NEW_CLICKED;
          break;
        case "productpages":
          eventId = PRODUCT_PAGE_EVENT.CREATE_NEW_CLICKED;
          break;
      }

      this.trackEvent({ event_id: eventId, properties: { text: this.btnText } });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-create {
  @include trans-all;
  display: inline-flex;
  i {
    font-size: 10px;
    font-weight: bold;
  }
  button {
    height: 40px;
    padding: 0px 10px;
  }
}
</style>
